import React from 'react';
import { IndigoAppContextType } from 'app/AppContext';
import Column from 'widgets/blotter/columns/Column';
import ColumnType from 'widgets/blotter/columns/ColumnType';

export const enumMapCellRenderer =
    <C extends ColumnType>(context: IndigoAppContextType, column: Column<C>) =>
    // eslint-disable-next-line react/display-name
    (props: { value: number }) =>
        props.value !== undefined ? (
            <span>{(column.enumMap as string[])![props.value]}</span>
        ) : (
            <span />
        );
